/**
 * ChatMessageGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { ChatMessageData } from './chat_message_data'

/**
 * ChatMessageGetRes
 */
export interface ChatMessageGetRes {
  /** 消息列表 */
  items?: ChatMessageData[]
}

/**
 * ChatMessageGetRes Schema
 */
export const ChatMessageGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '消息列表',
      format: '[]*model.ChatMessageData',
      items: { $ref: 'ChatMessageData', description: '' },
      type: 'array',
      label: '消息列表',
    },
  },
  type: 'object',
}
